import { Validators } from '@angular/forms';

import { FieldsOptions } from '@sim/form';

export interface Attachment {
  descrizione?: string;
  /** Id of the file */
  file: string;
  ordine: number;
  tipo?: 'immagine';
}

export const AttachmentMeta: FieldsOptions<Attachment> = {
  descrizione: { value: '' },
  file: { validators: [Validators.required] },
  ordine: { validators: [Validators.required] },
  tipo: { value: '' },
};
